<template>
    <div class="body">
        <div class="content">
            <img src="@/assets/mifi/title8.png" style="width: 100%;" />
            <!-- <van-tabs @click="onClick">
                <van-tab v-for="index in vanTab" :title="index" :key="index" />
            </van-tabs> -->
            <div class="weacher">
                <div class="weacher-r">
                    <img src="@/assets/mifi/notice_icon1.svg" alt="">
                    <div class="notice-box">有问题联系客服QQ:1587372322</div>
                    <!-- <van-icon name="arrow" /> -->
                </div>
            </div>

            <mt-loadmore :bottom-method="getAgentPrechargeListHandler" :bottom-all-loaded="allLoaded" :auto-fill="false"
                ref="loadmore">
                <van-row class="el-col-row">
                    <van-col span="12" v-for="item in wifiList" :key="item.id" @click.native="linkOpen(item)">
                        <div class="item-data">
                            <img :src="item.img" alt="" />
                            <div class="goodsTitle">{{ item.shareName }}</div>
                            <div class="goodsPrc">¥{{ item.sharePrice }}</div>
                        </div>
                    </van-col>
                </van-row>
            </mt-loadmore>
            <!-- <img src="@/assets/mifi/e6b.png" alt="" class="f-img"> -->
            <div class="copyRight" @click="goIntroduction">
                <div style="text-align: center;margin:14px 0;">深圳市雁云信息技术有限公司</div>
                <div style="text-align: center;margin-bottom:14px;">地址：深圳市龙华区民治街道民治社区1970科技园3栋201</div>
                <div style="text-align: center;margin-bottom:14px;">备案号：粤ICP备19128032号-1</div>
            </div>

            <!-- <div class="company">
                <p class="introduction" @click="goIntroduction">备案号</p>
                <p class="copy">
                    <span @click="goIntroduction">琼ICP备2024039174号-1</span>
                    <span @click="goIntroduction">海南市优享信息技术有限公司</span>
                    <br />
                </p>
            </div> -->


        </div>
        <div class="f-tab">
            <van-tabbar v-model="active" @change="onChange">
                <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from "vant";
export default {
    data() {
        return {
            dataList: [
                {
                    img: require('@/assets/mifi/29.png'), //首图
                    imga: require('@/assets/mifi/30.png'),//介绍图
                    imgb: require('@/assets/mifi/31.png'),//介绍图
                    shareName: 'POE交换机监控专用校园网宽带网络交换机网线分线器家用宿舍弱电箱',
                    sharePrice: '100.00',
                    type: '1',

                    name: '耀联',
                    name1: 'POE',
                    name2: '否',
                    name3: '1900Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '校园',
                    name7: '1900Mbps',
                    name8: '按年',
                },
                {
                    img: require('@/assets/mifi/2.jpg'), //首图
                    imga: require('@/assets/mifi/2a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/2b.jpg'),//介绍图
                    shareName: 'MF11 wifi路由器双频型，家用/网课/直播专用路由',
                    sharePrice: '50.00',
                    type: '1',
                    title: 'WIFI设备',
                    
                    name: '耀联',
                    name1: 'MF11',
                    name2: '否',
                    name3: '1500Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '家用',
                    name7: '1500Mbps',
                    name8: '按月',
                },
                {
                    img: require('@/assets/mifi/3.jpg'), //首图
                    imga: require('@/assets/mifi/3a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/3b.jpg'),//介绍图
                    shareName: 'TYC随身WIFI内置超强天线家用/商用/直播游戏/8K超清视频',
                    sharePrice: '35.00',
                    type: '1',
                    title: 'WIFI设备',

                    name: '耀联',
                    name1: 'TYC',
                    name2: '否',
                    name3: '2500Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '家用/商用/直播',
                    name7: '2500Mbps',
                    name8: '按月',
                },
                // {
                //     img: require('@/assets/mifi/4.jpg'), //首图
                //     imga: require('@/assets/mifi/4a.jpg'),//介绍图
                //     imgb: require('@/assets/mifi/64.jpg'),//介绍图
                //     shareName: 'MF12 2025款WIFI6改版大套餐随心用办公专属不卡顿',
                //     sharePrice: '120.00',
                //     type: '1',
                //     title: 'WIFI设备',

                //     name: '耀联',
                //     name1: 'MF12',
                //     name2: '否',
                //     name3: '2500Mbps',
                //     name4: '否',
                //     name5: '2.4G&5G',
                //     name6: '家用/商用/直播',
                //     name7: '2500Mbps',
                //     name8: '按月',
                // },
                {
                    img: require('@/assets/mifi/1.jpg'), //首图
                    imga: require('@/assets/mifi/1a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/65.jpg'),//介绍图
                    shareName: '2025新款上市升级WiFi6全国通用新款无线随身WIFI',
                    sharePrice: '35.00',
                    type: '1',
                    title: 'WIFI设备',

                    name: '耀联',
                    name1: '新款WIFI6 YP2型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&5G&wifi6',
                    name6: '场景通用',
                    name7: '1000Mbps',
                    name8: '按月',
                },

                {
                    img: require('@/assets/mifi/7.png'), //首图
                    imga: require('@/assets/mifi/8.png'),//介绍图
                    imgb: require('@/assets/mifi/66.jpg'),//介绍图
                    shareName: '全新增强型光猫路由器一体机四口千兆宽带猫无线猫5G猫',
                    sharePrice: '29.90',
                    type: '1',
                    title: 'WIFI设备',

                    name: '耀联',
                    name1: '24款家用YP型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&5G&wifi6',
                    name6: '家用',
                    name7: '1000Mbps',
                    name8: '按月',
                },

                {
                    img: require('@/assets/mifi/9.png'), //首图
                    imga: require('@/assets/mifi/10.png'),//介绍图
                    imgb: require('@/assets/mifi/67.jpg'),//介绍图
                    shareName: '光猫路由器一体智能无线路由器家用wifi高速穿墙王大功率千兆双频',
                    sharePrice: '19.9',
                    type: '1',
                    title: 'WIFI设备',

                    name: '耀联',
                    name1: 'JP1PRO 家用型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&5G&wifi6',
                    name6: '家用',
                    name7: '1000Mbps',
                    name8: '按月',
                },

                {
                    img: require('@/assets/mifi/5.png'), //首图
                    imga: require('@/assets/mifi/6.png'),//介绍图
                    imgb: require('@/assets/mifi/68.jpg'),//介绍图
                    shareName: '千兆路由器穿墙王全屋覆盖，家庭使用专属',
                    sharePrice: '12.90',
                    type: '1',
                    title: 'WIFI设备',

                    name: '耀联',
                    name1: 'JP1 家用型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '家用',
                    name7: '1000Mbps',
                    name8: '按月',
                },

                {
                    img: require('@/assets/mifi/60.jpg'), //首图
                    imga: require('@/assets/mifi/61.jpg'),//介绍图
                    imgb: require('@/assets/mifi/70.jpg'),//介绍图
                    shareName: '家用1200M双频路由器，学生网课WIFI路由设备',
                    sharePrice: '9.90',
                    type: '1',
                    title: 'WIFI设备',

                    name: '耀联',
                    name1: 'JP0 家用型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '校园',
                    name7: '1000Mbps',
                    name8: '',
                },
                {
                    img: require('@/assets/mifi/62.jpg'), //首图
                    imga: require('@/assets/mifi/63.jpg'),//介绍图
                    imgb: require('@/assets/mifi/71.jpg'),//介绍图
                    shareName: '3米专用路由连接线',
                    sharePrice: '2.90',
                    type: '1',
                    title: 'WIFI设备',

                    name: '耀联',
                    name1: '连接线',
                    name2: '否',
                    name3: '无',
                    name4: '否',
                    name5: '2.4G',
                    name6: '家用',
                    name7: '无',
                    name8: '',
                },

            ],
            active: 0,
            wifiList: [],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            agentId: '',
            vanTab: ['WIFI设备', '设备外设'],
            allLoaded: false,
            title: 'MIFI设备'
        }
    },
    created() {
        this.wifiList = this.dataList.filter(item => item.type === '1')
    },
    methods: {
        goIntroduction() {
            window.location.href = 'https://beian.miit.gov.cn/'
        },
        onClick(name, title) {
            this.title = title
            this.pageNo = 0
            this.getAgentPrechargeListHandler()
            this.wifiList = title === 'MIFI设备' ? this.dataList.filter(item => item.type === '1') : this.dataList.filter(item => item.type === '2')
        },
        getAgentPrechargeListHandler() {
            this.$refs.loadmore.onBottomLoaded();
            this.$nextTick(function () {
                window.scroll(0, 0);
            })
        },
        onChange(data) {
            console.log(data)
            if (data === 1) {
                this.$router.push({ path: '/ydai/userInfo' });
            }
        },
        linkOpen(data) {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                this.$router.push({ path: '/ydai/sumbit', query: { p: encodeURI(JSON.stringify(data)) } });
            } else {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "未查询到注册信息，请先注册账号！"
                })
                    .then(() => {
                        this.$router.push({ path: '/ydai/userInfo' });
                    })
                    .catch(() => { });
            }
        }
    }
}
</script>
<style lang="less" scoped>
.body {
    height: auto;
    width: 100%;
    padding-bottom: 163px;
    position: relative;
    background: rgb(235, 77, 46);

    .header {
        padding-bottom: 10px;

        img {
            width: 100%;
        }
    }

    // .item-data {
    //     padding: 10px;
    //     height:283px;
    //     img {
    //         width: 100%;
    //         max-height:175px;
    //     }

    //     .goodsTitle {
    //         font-size: 14px;
    //         font-weight: bold;
    //         color: #525253;
    //         line-height: 1.2rem;
    //         height:60px;
    //     }

    //     .goodsPrc {
    //         color: #CB353B;
    //         font-size: 18px;
    //         margin-top: 10px;
    //     }
    // }
    .van-col--12 {
        &:nth-child(2n) {
            .item-data {
                margin-left: 10px;
            }
        }
    }

    .item-data {
        border-radius: 13px;
        background: rgb(255, 255, 255);
        margin-top: 20px;

        img {
            width: 100%;
            /* // height:130px; */
            height: 190px;
            border-top-left-radius: 13px;
            border-top-right-radius: 13px;
        }

        .goodsTitle {
            font-size: 14px;
            font-weight: 500;
            color: #212121;
            /* // height: 40px;
            // overflow: hidden;
            // line-height: 1.2rem; */
            padding: 10px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            max-height: 2.0em;
            /* 2行行高的大约值 */
            line-height: 1.5em;
            /* 这里的行高应与你的实际行高相匹配 */
            white-space: normal;
            word-break: break-all;
        }

        .goodsPrc {
            color: rgb(255, 60, 41);
            font-size: 20px;
            margin-top: 10px;
            font-weight: 600;
            padding: 0 10px 10px;
        }
    }
}

.slecjg {
    width: 138px;
    height: 44px;
    background: #CB353B;
    font-size: 16px;
    color: #fff;
    border-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 20px;
    right: 0;
    left: 0;
    margin: 0 auto;
}

.f-img {
    margin: 6px 16px;
    margin-top: 40px;
    width: calc(100% - 32px);
}

.weacher-r {
    padding: 6px 16px;
    height: 50px;
    width: calc(100% - 32px);
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border-radius: 13px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin: 0 auto;

    img {
        width: 45px;
        height: 37px;
        position: relative;
        margin-right: 13px;
    }

    .notice-box {
        font-size: 16px;
        border-radius: 0;
        height: 22px !important;
        line-height: 22px;
        color: rgb(33, 33, 33);
    }

    .van-icon {
        flex: 1;
        text-align: right;
    }
}

.company {
    width: 40%;
    display: flex;
    position: absolute;
    bottom: 30px;
    left: 30%;
    color: #fff;
    border-top: 1px solid #fff;
    padding: 10px 0 0 10px;

    // font-family: '微软雅黑';
    .introduction {
        margin-right: 80px;
        cursor: pointer;

        &:hover {
            color: #f66;
        }
    }

    .copy {
        span:first-child {
            cursor: pointer;

            &:hover {
                color: #f66;
            }
        }

        span:nth-child(2) {
            cursor: pointer;

            &:hover {
                color: #f66;
            }
        }
    }
}


::v-deep .mint-loadmore-content {
    padding: 0 16px;
}
</style>